import React from 'react';
import {Select, Switch} from "antd";

const ComparisonParameters = () => {
    const onChange = () => {

    }
    return (
        <div className="ip-settings equipment-maintenance main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Comparison Parameters</span>
            </div>

            <div className="camera-config-content">
                <div className="my-avform">
                    <div className="row">
                        <div className="col-md-2 text-end text-white">Turn On Contrast Control</div>
                        <div className="col-md-4"><Switch defaultChecked onChange={onChange}/></div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Compare Thresholds</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                        <div className="col-md-2 text-white ">(50~100)</div>
                    </div>
                    <div className="row align-items-center mt-3">
                        <div className="col-md-2 text-end text-white">Turn On Contrast Control</div>
                        <div className="col-md-4 d-flex align-items-center">
                           <div>
                               <Switch defaultChecked onChange={onChange}/>
                           </div>
                            <div className="ml-16">
                                <Select

                                    placeholder="Поиск, чтобы выбрать"
                                    optionFilterProp="children"
                                    className="w-100"

                                >
                                    <option value="1">asd</option>
                                    <option value="3">asd</option>
                                    <option value="2">asd</option>
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Duration Of IO Output</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                        <div className="col-md-2 text-white ">ms (100~60000)</div>
                    </div>
                </div>
                <div className="offset-2 col-md-4 mt-3">
                    <button className="btn btn-primary">SET</button>
                </div>
            </div>

        </div>
    );
};

export default ComparisonParameters;